import Language from '../../../State/Stores/Captions/Constants/Language';

const normaliseLanguageCode = (languageCode: string): Language => {
    const strippedCode = languageCode.replace(/[^a-zA-Z]/g, '').toLowerCase();

    for (const languageCodeKey in Language) {
        const code = Language[languageCodeKey];

        if (code === strippedCode) return code as Language;
    }

    throw new RangeError(`Unrecognised text track language "${languageCode}" found in manifest`);
};

export default normaliseLanguageCode;